import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../../provider/providerManager';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import lodash from 'lodash';

export const getTvSubscriptions = createAsyncThunk('premiumPackages/getTvSubscriptions', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getTvSubscriptions', []);
    return result;
  } catch (error) {
    return error;
  }
});

export const getSocList = createAsyncThunk('premiumPackages/getSocList', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getSocList', [data]);
    /*tempExistedPackages
      { 
        name: pack.packageName.value,// PremiumPackageExistedCustomerContentData - עריכת תוכן
        //הצגת חבילות לרכישה
        packageName: 
        price:
        desktopImage: 
        mobileImage:
        channelsList: 
        isOnlyOneSubscription:
        isDailySubscriptionIncludes:
        lowestPrice
        //הצגת חבילות לרכישה

        description: עריכת תוכן
        isShowWarning:
        lawText:
        warningText:
        callbackCode: מגיע מתוך שדה בבלוק עצמו
        daysDuration:
        existedPackageOnly:  מגיע כחבילה קיימת בלבד (למשל תוכן למבוגרים)
        subscriptionList: מסלולים - מהקטלוג

        RemovedRemarkTextPopup: טקסט הסבר כיצד מחויב על מחזור חיוב חלקי - עריכת תוכן

        packIndex: packIndex,
        subscriptionIndex: subscriptionIndex,
        productID: subscription.productID.value, // SubscriptionsContentData - עריכת תוכן
        expired: found.expirationDate, //ממשק קטלוג
        serviceType: found.serviceType, //ממשק - לבדוק אם צריך
        socTitle: soc.socTitle.value, //SocContentData - עריכת תוכן
        socName: soc.socName.value, //SocContentData - עריכת תוכן
      }
    */
    //TODO: props.setExistingPackages(tempExistedPackages); // List of objects 
    //TODO: props.setSuggestedPackages(tempSuggestedPackages); // List of packageName
    return result;
  } catch (error) {
    return error;
  }
});

export const premiumPackageAction = createAsyncThunk('premiumPackages/premiumPackageAction', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('premiumPackageAction', [
      data.subscriberId,
      data.productId,
      data.action,
      data.subscriberNo,
      data.socName,
      data.socTitle,
      data.daysDuration
    ]);
    return result;
  } catch (error) {
    return error;
  }
});

const initialState = {
  cellcomTvList: null,
  selectedCellcomTvProd: null,
  isUserTvSuspended: false,
  socList: null,
  existingPackagesList: null,
  suggestedPackagesList: null,
  isShowPopup: false,
  isShowCellcomTvProd: false,
  isShowPackageDetails: false,
  isShowSubscriptionDetails: false,
  isUserCurrentSubscription: false,
  selectedPackageIndex: null,
  selectedSubscriptionIdx: null,
  userSubscriberIndex: null,
  isTermsAccepted: false,
  actionFail: false,
  actionSuccess: false,
  currentActionType: null,
  isShowConfirmTermsMsg: false,
  notTvUser: false,
  subscriptionPriceForDisplay: null,
  isGeneralError: false,
};

const premiumPackagesSlice = createSlice({
  name: 'premiumPackages',
  initialState: initialState,

  reducers: {
    clearAll: {
      reducer(state, action) {
        state.isShowPopup = false;
        state.cellcomTvList = null;
        state.socList = null;
        state.selectedCellcomTvProd = null;
        state.isShowPackageDetails = null;
        state.selectedPackageIndex = null;
        state.isShowSubscriptionDetails = null;
        state.selectedSubscriptionIdx = null;
        state.userPackageIndex = null;
        state.notTvUser = false;
        state.isUserTvSuspended = false;
        state.isGeneralError = false;
        state.isShowCellcomTvProd = false;
        state.isUserCurrentSubscription = false;
      },
    },
    goToPage: {
      reducer(state, action) {
        state.page = action.payload;
      },
    },
    reportAnalytics: (state, action) => {},
    showPopup: {
      reducer(state, action) {
        state.isShowPopup = action.payload;
      },
    },

    setCurrentActionType: {
      reducer(state, action) {
        state.currentActionType = action.payload;
      },
    },

    showPackageDetails: {
      reducer(state, action) {
        state.isShowPackageDetails = action.payload.show;
        state.selectedPackageIndex = action.payload.index;
        state.userPackageIndex = action.payload.userPackageIndex;
      },
    },
    showSubscriptionDetails: {
      reducer(state, action) {
        state.isShowSubscriptionDetails = action.payload.show;
        state.selectedSubscriptionIdx = action.payload.idx;
      },
    },

    setUserCurrentSubscription: {
      reducer(state, action) {
        state.isUserCurrentSubscription = action.payload;
      },
    },

    setExistingPackages: {
      reducer(state, action) {
        state.existingPackagesList = action.payload;
      },
    },

    setSuggestedPackages: {
      reducer(state, action) {
        state.suggestedPackagesList = action.payload;
      },
    },
    setUserSubscriberIndex: {
      reducer(state, action) {
        state.userSubscriberIndex = action.payload;
      },
    },

    setTermAgreement: {
      reducer(state, action) {
        state.isTermsAccepted = action.payload;
        state.isShowConfirmTermsMsg = false;
      },
    },
    setIsShowConfirmTermsMsg: {
      reducer(state, action) {
        state.isShowConfirmTermsMsg = action.payload;
      },
    },

    setSelectedCellcomTvProd: {
      reducer(state, action) {
        state.selectedCellcomTvProd = action.payload;
        state.isShowCellcomTvProd = false;
      },
    },

    setUserTvSuspended: {
      reducer(state, action) {
        state.isUserTvSuspended = action.payload;
      },
    },
    setConfirmRemoving: {
      reducer(state, action) {
        state.confirmRemoving = action.payload;
      },
    },

    setSubscriptionPriceForDisplay: {
      reducer(state, action) {
        state.subscriptionPriceForDisplay = action.payload;
      },
    },

    setActionSuccessToFalse: {
      reducer(state, action) {
        state.actionSuccess = false;
      },
    },
    setActionFailToFalse: {
      reducer(state, action) {
        state.actionFail = false;
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
  },
  extraReducers: {
    [getTvSubscriptions.fulfilled]: (state, action) => {
      if (action.payload.errorCode) {
        state.isGeneralError = true;
      }
      if (action.payload.Body) {
        if (action.payload.Body.length > 0) {
          state.cellcomTvList = action.payload.Body;
          if (action.payload.Body.length > 1) {
            state.isShowCellcomTvProd = true;
          } else {
            state.selectedCellcomTvProd = action.payload.Body[0];
          }
        } else {
          state.notTvUser = true;
        }
      } else {
        state.notTvUser = true;
      }
    },
    [getSocList.fulfilled]: (state, action) => {
      if (action.payload.Body) {
        if (action.payload.Body.soc.some((n) => n.socName.trim() == 'TVBLKK')) {
          state.socList = false;
        } else {
          state.socList = action.payload.Body.soc;
        }
      } else {
        state.isGeneralError = true;
      }
    },
    [premiumPackageAction.fulfilled]: (state, action) => {
      if (action.payload.errorCode) {
        state.actionFail = true;
      }
      if (action.payload.Body) {
        if (action.payload.Body.returnCode == '00') {
          state.actionSuccess = true;
        } else {
          state.actionFail = true;
        }
      } else {
        state.actionFail = true;
      }
    },
  },
});

export const {
  showPopup,
  changeHandler,
  showPackageDetails,
  showSubscriptionDetails,
  goToPage,
  setSuggestedPackages,
  setExistingPackages,
  setUserCurrentSubscription,
  setUserSubscriberIndex,
  setTermAgreement,
  setSelectedCellcomTvProd,
  setCurrentActionType,
  reportAnalytics,
  setIsShowConfirmTermsMsg,
  setSubscriptionPriceForDisplay,
  setActionSuccessToFalse,
  setActionFailToFalse,
  clearAll,
  setUserTvSuspended,
} = premiumPackagesSlice.actions;

export default premiumPackagesSlice.reducer;
